import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { RoleModalComponent } from '../role-modal/role-modal.component';

@Component({
  selector: 'app-update-role',
  templateUrl: './update-role.component.html',
  styleUrl: './update-role.component.scss',
  standalone: false
})
export class UpdateRoleComponent implements OnInit{
  roleManagementForm!: FormGroup;
  isLoadingPrivileges: boolean = true;
  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  privileges: any[] = null;
  isLoading: boolean = false;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UpdateRoleComponent>,
    @Inject(MAT_DIALOG_DATA) public editModeData: any,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {

    this.initForm();

    this.getAllPrivileges();
  }

  initForm(): void {

    this.initializeRoleForm();

    this.roleManagementForm = this.fb.group({
      name: [{ value: this.editModeData?.name || '', disabled: true }, Validators.required],
      description:  [this.editModeData?.description || '', [Validators.required, Validators.maxLength(120)]],
      privileges: [[], Validators.required],
    });
  }

  initializeRoleForm(){
    this.roleManagementForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      privileges: [[], Validators.required],
    });
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload()
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }


  openConfirmModal() {

        this.dialog.open(ConfirmActionComponent, {
          width: '400px',
          backdropClass: 'modal-form-backdrop',
          hasBackdrop: true,
          panelClass: ['modal-form', 'modal-no-overflow-changed'],
          disableClose: true,

          data: {
            title: "Confirm role update?",
            body: '',
            confirmText: 'Yes',
            lottieIconPath: 'assets/lottie/alert.json',
            onConfirm: () => {

              this.saveRole()
            },
            onCancel: () => {

            },
            showCancelButton: true,
            showConfirmButton: true,
          },
        });

  }

  getAllPrivileges() {
    this.isLoading = true;
    this.apiService
      .get('/privileges/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.privileges = response.data.map((priv) => ({
          ...priv,
        }));

        setTimeout(() => {
          this.setPrivileges();
        }, 0);
      });
  }


  setPrivileges() {
    if (!this.editModeData?.priviliages?.length || !this.privileges?.length) {
      return;
    }

    const selectedPrivilegeIds = this.editModeData.priviliages
      .map((privilege: any) => privilege.privilegeId)
      .filter((id: any) => this.privileges.some(p => p.privilegeId === id));

    this.roleManagementForm.get('privileges')?.setValue(selectedPrivilegeIds);
  }



  toggleSelection(item: any, selected: boolean, event: Event) {
    event.stopPropagation();

    setTimeout(() => {
      const control = this.roleManagementForm.get('privileges');
      let selectedValues = [...(control?.value || [])];

      if (selected) {

        selectedValues = selectedValues.filter((id: any) => id !== item.privilegeId);
      } else {

        selectedValues.push(item.privilegeId);
      }

      control?.setValue(selectedValues);
      control?.updateValueAndValidity();

      control.markAsDirty()
    });
  }

  isSelected(item: any): boolean {
    const selectedValues = this.roleManagementForm.get('privileges')?.value || [];
    return selectedValues.includes(item.privilegeId);
  }


  toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  selectAll(ngSelect: NgSelectComponent, controlName: string) {
    const control = this.roleManagementForm.get(controlName);
    if (control) {
      control.setValue(this.privileges.map(p => p.privilegeId));
      control.markAsDirty();
      ngSelect.close();
    }
  }

  closeModal(): void {
    this.initializeRoleForm()
    this.dialogRef.close();
  }


  saveRole(): void {
    this.isSubmitAttempted = true;

    if (this.roleManagementForm.valid) {
      const formData = this.roleManagementForm.value;

      const roleRequest = {
        id: this.editModeData.roleId,
        name: formData.name,
        description: formData.description,
        privilegeIds: formData.privileges,
      };

      this.isSubmitting = true;

      const url = '/roles/update'

      this.apiService
      .post(url, roleRequest)
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe(
        () => {
          this.openSuccessModal('Role updated successfully');

        },
        (error) => {
          this.openErrorModal(error?.message)
        }
      );
    }
  }


}
